<template>
  <div class="custom-control custom-radio">
    <input type="radio"
           :id="`custom-radio-${_uid}`"
           :name="name"
           class="custom-control-input"
           :value="val"
           :required="required"
           @change="$emit('input', $event.target.value)">
    <label class="custom-control-label"
           :for="`custom-radio-${_uid}`"
    >{{ val }}</label>
  </div>
</template>

<script>
export default {
  props: {
    val: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
